import { render } from "./Plan.vue?vue&type=template&id=550d70f7"
const script = {}

import exportComponent from "E:\\ALCON\\_DEV\\dhs-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__